import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { SelectedNoteFilter } from "../../util/common";
// import { timeProvider } from "../../AppController";

export interface IPatientStateSlice {
  recentlyReviewed: number[];
  pccNotesFilter: IPatientPCCNoteFilterState;
  circadiaNotesFilter: ICircadiaNoteFilterState;
  ipvSelectedNote: string | null;
}

const name = "patient";

export const initialState: IPatientStateSlice = {
  recentlyReviewed: [],
  pccNotesFilter: {
    date: 1,
    customDate: {
      start: "",
      end: "",
    },
  },
  circadiaNotesFilter: {
    date: 1,
    noteType: [
      SelectedNoteFilter.CLINICAL_NOTES,
      SelectedNoteFilter.ORDER_NOTES,
    ],
    customDate: {
      start: "",
      end: "",
    },
  },
  ipvSelectedNote: null,
};

export const patientSlice = createSlice({
  name,
  initialState,
  reducers: {
    addRecentlyReviewed(state, action: PayloadAction<number[]>) {
      state.recentlyReviewed = action.payload;
    },
    setPatientPCCNoteFilters(
      state,
      action: PayloadAction<Partial<IPatientPCCNoteFilterState>>
    ) {
      state.pccNotesFilter = {
        ...state.pccNotesFilter,
        ...action.payload,
      };
    },
    setPatientCircadiaNoteFilters(
      state,
      action: PayloadAction<Partial<ICircadiaNoteFilterState>>
    ) {
      state.circadiaNotesFilter = {
        ...state.circadiaNotesFilter,
        ...action.payload,
      };
    },
    setRecentlyReviewedReset(state) {
      state.recentlyReviewed = [];
    },
    setIpvSelectedNote(state, action: PayloadAction<string | null>) {
      state.ipvSelectedNote = action.payload;
    },
  },
});

export const {
  addRecentlyReviewed,
  setPatientPCCNoteFilters,
  setPatientCircadiaNoteFilters,
  setRecentlyReviewedReset,
  setIpvSelectedNote,
} = patientSlice.actions;

const persistedReducer = persistReducer(
  {
    key: name,
    storage: storage,
    whitelist: ["recentlyReviewed", "pccNotesFilter", "circadiaNotesFilter"],
  },
  patientSlice.reducer
);

export default persistedReducer;
